import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/operationlogs';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async history(params: any) {
    return api.history(params);
  }
}
